import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { Routes, Route, Navigate } from "react-router-dom";
import { RouteTracker } from "./RouteTracker";
import DashboardLayout from "../Gerneralcomponents/Dasboard/DashboardLayout";

//Public
import Register from "../Views/OutLog/Register/Register";
import RegisterCampaign from "../Views/OutLog/Register/RegisterCampaign";
import RegisterEmpresarial from "../Views/OutLog/Register/RegisterEmpresarial";
import Cotizador from "../Gerneralcomponents/Cotizardor/Cotizardortest";
import Login3 from "../Views/OutLog/Login/Login3";
import Recuperar from "../Views/OutLog/OlviPassword/olvi";
import Recuperarcontra from "../Views/OutLog/OlviPassword/recontra";
import ActivateAccount from "../Views/OutLog/Activationlan/ActivateAccount";
import Home from "../Views/OutLog/Home/Home";
import AdminComp from "../Gerneralcomponents/Admin/AdminWifi/AdminComp";
import Respass from "../Views/OutLog/OlviPassword/respass";
import { Loader } from "../Loader/Loader";
import Prueba2 from "../Gerneralcomponents/Dasboard/Contract/DocData"; 
import ConfirmAddNewService from "../Views/OutLog/AceptarAgregarServicio/ConfirmAddNewService";
import ConfirmActivateTvService from "../Views/OutLog/ConfirmActivateTvService/ConfirmEMTVPlusActivation";
import ConfirmEmpresarial from "../Views/OutLog/ConfirmEmpresarial/ConfirmEmpresarial";

//Private
import PolygonComp from "../Gerneralcomponents/Admin/Polygon/PolygonComp";

import { PolygonSearch } from "../Gerneralcomponents/Admin/Polygon/PolygonSearch";
import { CreateSol } from "../Gerneralcomponents/Admin/CreateBuynew/createSol";
import { Cotizadorsol } from "../Gerneralcomponents/Admin/CotizadorSol/Cotizadorsol";
import { Emailfind } from "../Gerneralcomponents/Admin/EmailFind/Emailfind";
import { Selectypebuy } from "../Gerneralcomponents/Admin/Selectypebuy/Selectypebuy";
import { EmpaquetarLogin } from "../Gerneralcomponents/Admin/CotizadorSol/EmpaquetarLogin";
import { Sendemail } from "../Gerneralcomponents/Dasboard/SendEmail/sendemail";

// import Dashunycompra from "../Gerneralcomponents/Dasboard/Dashcompra/Dashunycompra";
// import PolygonAdd from "../Gerneralcomponents/Admin/Polygon/PolygonComp";
// import { PolygonEdit } from "../Gerneralcomponents/Admin/Polygon/PolygonEdit";
import { SolicitudLogin } from "../Gerneralcomponents/Admin/CotizadorSol/SolicitudLogin";
import { SolicitudLoginUny } from "../Gerneralcomponents/Admin/CotizadorSol/SolicitudLoginUny";
import {MapaCobertura} from "../Gerneralcomponents/CoberturaFTTH/MapaCobertura";
import { OrdersBuy } from "../Gerneralcomponents/Dasboard/Solicitud/OrdersBuy";
import { TrackingPage } from "../Gerneralcomponents/Dasboard/Solicitud/SolicitudFUn/tracking/TrackingPage";
import CausalAnul from "../Gerneralcomponents/Admin/CausalAnu/CausalAnul";
import { WifiManager } from "../Gerneralcomponents/Admin/WifiManager/WifiManager";
import LandingProduct from "../../Empresarial/HomeEmpresarial/LandingProduct";






// import Registerout from "../Views/OutLog/Register/Registerout";

export default function NavigationRoutes() {
  const steps0 = [
    {
      label: "Comprueba tu cobertura",
    },
    {
      label: "Selecciona tu paquete",
    },
    {
      label: "Registar usuario",
    },
    {
      label: "Registrar solicitud",
    },
  ];

  const steps1 = [
    {
      label: "Selecciona tu paquete",
    },
    {
      label: "Comprueba tu cobertura",
    },
    {
      label: "Registar usuario",
    },
    {
      label: "Registrar solicitud",
    },
  ];

  const steps3 = [
    {
      label: "Comprueba tu cobertura",
    },
    {
      label: "Selecciona tu paquete",
    },

    {
      label: "Registrar solicitud",
    },
  ];

  const steps4 = [
    {
      label: "Por Firmar",
    },
    {
      label: "Firmado",
    },
    {
      label: "En Proceso",
    },
    {
      label: "Por Agendar",
    },
  ];

  const Question = lazy(() => import("../Gerneralcomponents/Queston/Question"));
  const AddWin = lazy(() =>
    import(
      "../Gerneralcomponents/Admin/AdminServices/AddicionalServices/AddWin"
    )
  );
  const Addipfija = lazy(() =>
    import(
      "../Gerneralcomponents/Admin/AdminServices/AddicionalServices/Addipfija"
    )
  );
  //Administracion de mis servicios
  const AdminSol = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminServices/AdminSol")
  );
  //Servicios empresariales - Sedes
  const Sedes = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminServiciosEmpresariales/Sedes")
  );
  //Servicios empresariales - Reportes PQR
  const ReportesPQR = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminServiciosEmpresariales/ReportesPQR")
  );
  const CrearReportePQR = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminServiciosEmpresariales/CrearReportePQR")
  );
  const PlanDetails = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminServices/PlanDetails")
  );
  //Solicitudes de servicio
  const Solicitudes = lazy(() =>
    import("../Gerneralcomponents/Dasboard/Solicitud/Solicitudes")
  );
  const Finalbuy = lazy(() =>
    import("../Gerneralcomponents/Dasboard/Finalbuy/Finalbuy")
  );
  const CallSolicitudes = lazy(() =>
    import("../Gerneralcomponents/Dasboard/Callsolicitudes/CallSolicitudes")
  );
  const Campaings = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminCampaing/Campaings")
  );
  const Dashboardprincipal = lazy(() =>
    import("../Gerneralcomponents/Dasboard/Dashprincipal/Dashprincipal")
  );
  // const Dashcompra = lazy(() =>
  //   import("../Gerneralcomponents/Dasboard/Dashcompra/Dashcompra")
  // );

  const Rescorreo = lazy(() => import("../Views/OutLog/OlviMail/olvicorreo"));
  const PrivateRoutes = lazy(() => import("./PrivateRoutes"));
  const OtherProtectedRoutes = lazy(() => import("./OtherRoutes"));

  const Valout = lazy(() =>
    import("../Gerneralcomponents/CoberturaFTTH/valout")
  );
  const PreBuy = lazy(() =>
    import("../Gerneralcomponents/Cotizardor/prebuy")
  );
  const Intpersonas = lazy(() =>
    import("../Views/OutLog/Services/Internet/Internet")
  );
  const Television = lazy(() =>
    import("../Views/OutLog/Services/Television/Television")
  );
  const Telefone = lazy(() =>
    import("../Views/OutLog/Services/Telefonia/Telefonia")
  );

  const Contract = lazy(() =>
    import("../Gerneralcomponents/Dasboard/Contract/Contract")
  );
  const Landindingcompra = lazy(() =>
    import("../Views/OutLog/Landings/Landindingcompra")
  );

  const Increaseplan = lazy(() =>
    import("../Gerneralcomponents/IncreasePlan/Increaseplan")
  );
  const AddEmtvPlus = lazy(() =>
    import("../Gerneralcomponents/IncreasePlan/AddEmtvPlus")
  );
  const AdminImages = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminImage/AdminImages")
  );

  const AdminEmpresarial = lazy(() =>
    import("../Gerneralcomponents/Admin/AdminEmpresarial/AdminEmpresarial")
  );


  const Empaquetarin = lazy(() =>
    import("../Gerneralcomponents/Empaquetar/Empaquetarin")
  );
  const Empaquetarout = lazy(() =>
    import("../Views/OutLog/EmpaquetarOut/Empaquetarout")
  );

  const Guiauso = lazy(() => import("../Landing/Guias/guiauso"));
  const Suspension_voluntaria = lazy(() =>
    import("../Views/OutLog/Masivo/suspension_voluntaria")
  );
  const Suspension = lazy(() =>
    import("../Views/OutLog/Masivo/suspension")
  );
  const Suspension_plan = lazy(() =>
    import("../Views/OutLog/Masivo/suspension_plan")
  );
  const Inconsistentes = lazy(() =>
    import("../Views/OutLog/Masivo/inconsistentes")
  );
  const Medidor = lazy(() =>
    import("../Gerneralcomponents/Medidor/Medidor")
  );

  const Tvgrilla = lazy(() =>
    import("../Gerneralcomponents/Admin/Grilla/Tvgrilla")
  );
  const Grilla = lazy(() => import("../Views/OutLog/Grilla/Grilla"));
  const OrdersBuyEmpresarial = lazy(() => import("../Gerneralcomponents/Dasboard/SolicitudEmpresa/OrdersBuyEmpresarial"));
  const OrdersBuyEmpresarialce = lazy(() => import("../Gerneralcomponents/Dasboard/SolicitudEmpresa/OrdersBuyEmpresarialce"));
  const FormEmpresarial = lazy(() => import("../../Empresarial/HomeEmpresarial/FormEmpresarial"));
  const SelectProdEmpresarial = lazy(() => import("../../Empresarial/HomeEmpresarial/SelectProdEmpresarial"));
  const HomeEmpresarial = lazy(() => import("../../Empresarial/HomeEmpresarial/HomeEmpresarial"));
  
  
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <RouteTracker />
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route element={<DashboardLayout />}>
              <Route element={<WifiManager />} path="/Administrator/:id" exact />
              <Route element={<AdminSol />} path="/AdminSol" exact />
              <Route element={<PlanDetails />} path="/planDetails" exact />
              <Route element={<Sedes />} path="/Sedes" exact />
              <Route element={<ReportesPQR />} path="/ReportesPQR" exact />
              <Route element={<CrearReportePQR />} path="/ReportesPQR/Crear" exact />
            </Route>
            <Route path="/adm" element={<AdminComp />} />
            <Route element={<Increaseplan />} path="/Increaseplan/:id" exact />
            <Route element={<AddEmtvPlus />} path="/AddEmtvPlus/:id" exact />
            <Route element={<Addipfija />} path="/Addipfija/:id" exact />
            <Route element={<Contract />} path="/Contract/:id" exact />

            <Route element={<CallSolicitudes />} path="/CallSolicitudes/:id" />
            <Route element={<Campaings />} path="/Campaings" />
            <Route element={<Tvgrilla />} path="/Tvgrilla" />
            <Route element={<CausalAnul />} path="/CausalAnul" />

            
            <Route element={<PolygonComp />} path="/Polygon" />
            <Route element={<PolygonSearch />} path="/PolygonEdit/:id" />
            <Route element={<OrdersBuy />} path="/Solicitud/:id" />
            <Route element={<TrackingPage />} path="/Solicitud/tracking/:id" />
            <Route element={<OrdersBuyEmpresarial />} path="/SolicitudEmpresarial" />
            <Route element={<OrdersBuyEmpresarialce />} path="/SolicitudEmpresarialCe" />
            
            <Route
              element={<Dashboardprincipal />}
              path="/Dashboardprincipal"
            />
            <Route
              element={<Dashboardprincipal />}
              path="/Dashboardprincipal"
            />
            <Route element={<Sendemail />} path="/sendemail" />
            <Route element={<Emailfind />} path="/Dashunycompra" />
            <Route
              path="/createSolPer"
              element={
                <CreateSol
                  ruta={"/CotizadorsolPer"}
                  step={1}
                  steps={steps3}
                  classBack={""}
                  classDiv={""}
                />
              }
            />
            <Route
              path="/createSol"
              element={
                <CreateSol
                  ruta={"/Cotizadorsol"}
                  step={1}
                  steps={steps3}
                  classBack={""}
                  classDiv={""}
                />
              }
            />
            <Route
              path="/createSolEmp"
              element={
                <CreateSol
                  ruta={"/CotizadorsolEmp"}
                  step={1}
                  steps={steps3}
                  classBack={"prin"}
                  classDiv={"cont"}
                />
              }
            />
            <Route path="/Selectypebuy" element={<Selectypebuy />} />
            <Route
              element={<Cotizadorsol funcionExe={SolicitudLogin} Mcompra={"active"} Mcunyompra={""}/>}
              path="/CotizadorsolPer"
            />
            <Route
              element={<Cotizadorsol funcionExe={SolicitudLoginUny} Mcompra={""} Mcunyompra={"active"}/>}
              path="/Cotizadorsol"
            />
            <Route
              element={<Cotizadorsol funcionExe={EmpaquetarLogin} Mcompra={""} Mcunyompra={"active"}/>}
              path="/CotizadorsolEmp"
            />
            <Route element={<OrdersBuy steps={steps4} />} path="/Solicitud" />
            <Route element={<Solicitudes steps={steps4} />} path="/Reportes/:id" />
            <Route element={<AdminImages />} path="/AdminImages" />
            <Route element={<AdminEmpresarial />} path="/AdminEmpresarial" />
            
            <Route
              element={
                <Empaquetarin
                  ruta={"/createSolEmp"}
                  Servicemp={"active"}
                  name={"namedasRes"}
                  Tel={"phoneRes"}
                  dni={"cedulaRes"}
                  uniBuy={""}
                />
              }
              path="/Empaquetarin"
            />
            <Route
              element={
                <Empaquetarin
                  ruta={"/createSolEmp"}
                  Servicemp={""}
                  name={"namedasRes"}
                  Tel={"phoneRes"}
                  dni={"cedulaRes"}
                  uniBuy={"active"}
                />
              }
              path="/EmpaquetarinU"
            />
          
            <Route path="*" element={<Navigate to="/Dashboardprincipal" />} />
            <Route path="/AddWin/:id" element={<AddWin />} />
          </Route>
          <Route element={<OtherProtectedRoutes />}>
            <Route path="/Login" element={<Login3 />} />
            <Route
              path="/portalescautivos/masivo/inconsistentes/"
              element={<Inconsistentes />}
            />
            <Route
              path="/portalescautivos/masivo/suspension_plan/"
              element={<Suspension_plan />}
            />
            <Route
              path="/portalescautivos/masivo/suspension_voluntaria/"
              element={<Suspension_voluntaria />}
            />
            <Route
              path="/portalescautivos/masivo/suspension/"
              element={<Suspension />}
            />
            <Route element={<MapaCobertura />} path="/Mapano" />
            <Route path="/RegisterCampaign" element={<RegisterCampaign
              ruta={"/Login"}
              stepper={"none"}
              options={""}
              inputwidht={"15rem"}
            />} />
            <Route
              path="/Register"
              element={
                <Register
                  ruta={"/Login"}
                  stepper={"none"}
                  options={""}
                  inputwidht={"15rem"}
                />
              }
            />
            <Route
              path="/RegisterEmpresarial"
              element={<RegisterEmpresarial />}
            />
            <Route
              path="/Registerout"
              element={
                <Register
                  ruta={"/Compraout"}
                  stepper={""}
                  options={"none"}
                  inputwidht={"20rem"}
                />
              }
            />
            <Route path="/grilla" element={<Grilla />} />
            <Route path="/Recuperarcontra" element={<Recuperarcontra />} />
            <Route path="/ConfirmAddNewService" element={<ConfirmAddNewService />} />
            <Route path="/ConfirmEMTVPlusActivation" element={<ConfirmActivateTvService />} />
            <Route path="/Recuperarcontra1/" element={<Respass />} />
            <Route path="/Recuperarcontra2" element={<ConfirmEmpresarial />} />
            <Route path="/Recuperarcorreo" element={<Rescorreo />} />
            <Route path="/Recuperar" element={<Recuperar />} />
            <Route path="/Cotizador" element={<Cotizador />} />
            <Route
              path="/Compraout"
              element={<Finalbuy stepper={steps1} step={3} />}
            />
            <Route path="/Empaquetarout" element={<Empaquetarout />} />
            <Route path="/Guiauso" element={<Guiauso />} />
            <Route
              path="/valout"
              element={
                <Valout
                  ruta={"/Registerout"}
                  step={1}
                  steps={steps1}
                  classBack={"prin"}
                  classDiv={"cont"}
                />
              }
            />
            <Route
              path="/prebuy"
              element={
                <PreBuy
                />
              }
            />
            <Route
              path="/valoin"
              element={
                <Valout
                  ruta={"/planesin"}
                  step={0}
                  steps={steps0}
                  classBack={"prin"}
                  classDiv={"cont"}
                />
              }
            />
            <Route path="/Ayuda" element={<Question />} />
            <Route path="/Intpersonas" element={<Intpersonas />} />
            <Route path="/tvpersonas" element={<Television />} />
            <Route path="/Telefoniapersonas" element={<Telefone />} />
            <Route
              path="/ActivateAccount"
              element={<ActivateAccount />}
            ></Route>
            <Route path="/Medidor" element={<Medidor />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
          <Route
            path="/planes"
            element={
              <Landindingcompra
                ruta={"/valout"}
                nombreButton={"Adquirir producto"}
              />
            }
          />
          <Route
            path="/cotizadores"
            element={
              <Landindingcompra
                ruta={"/valout"}
                nombreButton={"Adquirir producto"}
              />
            }
          />
          <Route
            path="/Empresarial"
            element={
              <HomeEmpresarial
                ruta={"/Empresarial"}
                nombreButton={"Adquirir producto"}
              />
            }
          />
          <Route
            path="/SelBuyEmpresarial"
            element={
              <SelectProdEmpresarial
                ruta={"/Empresarial"}
                nombreButton={"Adquirir producto"}
              />
            }
          />
          <Route
            path="/FormEmpresarial"
            element={
              <FormEmpresarial
                ruta={"/Empresarial"}
                nombreButton={"Adquirir producto"}
              />
            }
          />
          
          <Route
            path="/planesin"
            element={
              <Landindingcompra
                ruta={"/Registerout"}
                nombreButton={"Adquirir producto"}
              />
            }
          />
          <Route
            path="/planesin1"
            element={
              <Landindingcompra
                ruta={"/Registerout"}
                nombreButton={"Compra producto"}
              />
            }
          />
          <Route
            path="/LandingProduct"
            element={
              <LandingProduct/>
            }
          />
          <Route
            path="/PruebaDocData/:id"
            element={
              <Prueba2/>
            }
          />
        </Routes>
      </Router>
    </Suspense>
  );
}
